import React from "react";
import PropTypes from "prop-types";
import {Search} from "../../Components/Search/";
import MapBlocksToComponents from "Helpers/BlockHelper";
import {PageTransition} from "Animations";

let ListPageWithCategories = ({
  searchModel,
  Heading,
  SearchText,  
  Breadcrumbs,
  ShowMoreText,
  ElementArea,
  ShowPriorityItem,
}) => {
  return (
    <>
      {/*<BreadcrumbsComp Items={Breadcrumbs} />*/}
      <PageTransition>
        {ElementArea?.length > 0 && MapBlocksToComponents(ElementArea)}
      </PageTransition>
      <Search
        {...{ ShowMoreText, SearchText, Heading, ShowPriorityItem }}
        {...searchModel}
        hideField={true}
        withCategories={true}
        isNewDesign={true}
      />
    </>
  );
};

ListPageWithCategories.propTypes = {
  Heading: PropTypes.string,
};

export default ListPageWithCategories;
